import { render, staticRenderFns } from "./DeliveryCampaignGroupsUpdatePage.vue?vue&type=template&id=251c1c5d&scoped=true"
import script from "./DeliveryCampaignGroupsUpdatePage.vue?vue&type=script&lang=js"
export * from "./DeliveryCampaignGroupsUpdatePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251c1c5d",
  null
  
)

export default component.exports